import { useState } from 'react';
import { CollapsibleCard, type ToolRendererProps } from '../ToolCard';

interface SearchResult {
  title?: string;
  url?: string;
  snippet?: string;
  description?: string;
}

export function WebSearchCard({ toolName, result }: ToolRendererProps) {
  const [showAll, setShowAll] = useState(false);

  let results: SearchResult[] = [];
  if (Array.isArray(result)) {
    results = result as SearchResult[];
  } else if (result && typeof result === 'object') {
    const obj = result as Record<string, unknown>;
    for (const k of ['results', 'items', 'data']) {
      if (Array.isArray(obj[k])) {
        results = obj[k] as SearchResult[];
        break;
      }
    }
  }

  const visible = showAll ? results : results.slice(0, 5);

  return (
    <CollapsibleCard toolName={toolName} defaultOpen>
      <div className="text-[11px] text-bark">{results.length} web results</div>
      <ol className="mt-1 space-y-2">
        {visible.map((r, i) => (
          <li key={r.url ?? i} className="text-xs">
            <div className="font-medium text-espresso">
              <span className="mr-1 text-bark/60">{i + 1}.</span>
              {r.title ?? '(untitled)'}
            </div>
            {r.url && (
              <a
                href={r.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block truncate text-[10px] text-gold hover:underline"
              >
                {r.url}
              </a>
            )}
            {(r.snippet || r.description) && (
              <div className="mt-0.5 line-clamp-3 text-bark">
                {r.snippet ?? r.description}
              </div>
            )}
          </li>
        ))}
      </ol>
      {!showAll && results.length > 5 && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="mt-1 text-[11px] text-gold hover:underline"
        >
          Show {results.length - 5} more
        </button>
      )}
    </CollapsibleCard>
  );
}
